module.exports = __webpack_public_path__ + "img/checkout-mobile-responsive.de9f89bc.svg";